class orderAdd_mok{
    static getorderAdd(order){
        return new Promise((resolve,reject)=>{
            setTimeout(() => {
                resolve({
                    status:{
                        code:1,
                        massage:"با موفقیت اضاف شد"
                       }
                })
            }, 1000);
        })
    }
}
export {orderAdd_mok}